// src/constants/Constants.js - Clean version (no SQL)

export const BASE_URL = "https://api.divinedepot.in";
//export const BASE_URL = "http://localhost:5001";

// API Endpoints
export const API_ENDPOINTS = {
  LOGIN: "/users/loginUser",
  FORGOT_PASSWORD: "/forgotPassword",
  REGISTER: "/users/register"
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_ID: "userId",
  USER_EMAIL: "userEmail",
  USER_TYPE: "userType",
  IS_LOGGED_IN: "isLoggedIn"
};

// Configuration
export const CONFIG = {
  TIMEOUT: 10000,
  MAX_FILE_SIZE: 20 * 1024 * 1024  // 20MB
};

// User Types
export const USER_TYPES = {
  ADMIN: "ADMIN",
  USER: "USER"
};

// Default Values for Testing
export const DEFAULT_CREDENTIALS = {
  ADMIN_EMAIL: "admin@admin.com",
  ADMIN_PASSWORD: "admin"
};
